module.exports = __webpack_public_path__ + "img/embed-video.ed41ee91.svg";